module.exports = __webpack_public_path__ + "static/img/bc-1.cdf2f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc-1.png
// module id = Sj7M
// module chunks = 0